module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8n3r6n-cbe0bc137527b5de4357c7fad738c4e2.svg";